import { Feature, createActionFactoryForFeature } from '../../shared';

const actionFactory = createActionFactoryForFeature(Feature.UnifiedGroups);
export const inviteToGroupClickedAction = actionFactory<{}>('InviteToGroupClickedAction');

export const dismissInviteToGroupDialogAction = actionFactory<{}>(
    'DismissInviteToGroupDialogAction'
);
